import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';

/** Sticky banner shown on authenticated pages if the user's email is not yet
 *  verified. Stays visible until they click the link in their inbox + verify.
 *  Resend button re-emits a fresh link. */
export default function VerifyBanner() {
  const { user } = useAuth();
  const [busy, setBusy]       = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');

  if (!user || user.emailVerified) return null;

  const resend = async () => {
    setBusy(true); setError('');
    try {
      await authAPI.resendVerification();
      setSent(true);
    } catch (e) {
      setError(e.response?.data?.error || 'Could not resend. Try again in a minute.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={wrap} role="status">
      <span style={icon}>📧</span>
      <span style={text}>
        Verify your email <strong>{user.email}</strong> to unlock all features.{' '}
        {sent
          ? <span style={sentMsg}>✓ Sent. Check your inbox.</span>
          : <button type="button" onClick={resend} disabled={busy} style={btn}>
              {busy ? 'Sending…' : 'Resend link'}
            </button>}
        {error && <span style={errMsg}> — {error}</span>}
      </span>
    </div>
  );
}

const wrap = {
  background: '#fffbeb',
  borderBottom: '1px solid #fde68a',
  padding: '0.7rem 1.5rem',
  display: 'flex', alignItems: 'center', gap: '0.65rem',
  fontFamily: "'Inter', sans-serif",
  fontSize: '0.88rem', color: '#78350f',
  flexWrap: 'wrap',
};
const icon = { fontSize: '1rem' };
const text = { lineHeight: 1.5 };
const btn = {
  background: '#92400e', color: 'white',
  border: 'none', borderRadius: 8,
  padding: '0.3rem 0.7rem',
  fontWeight: 700, fontSize: '0.8rem',
  cursor: 'pointer',
  fontFamily: 'inherit',
  marginLeft: '0.2rem',
};
const sentMsg = { color: '#065f46', fontWeight: 700 };
const errMsg  = { color: '#b91c1c' };
